module.exports = __webpack_public_path__ + "static/img/auto_power_off.dcca6f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trackplus_2021/auto_power_off.png
// module id = 9WCC
// module chunks = 1